import type React from 'react';
import { useState } from 'react';

import { useParams } from 'react-router-dom';

import SendSMSDialog from 'components/dialogs/sendMessageDialog/SendSMSDialog';
import { useSmsService } from 'hooks/sms/useSmsService';
import { type MatchUpInterface } from 'typedefs/store/scheduleTypes';
import { type ParticipantInterface } from 'typedefs/store/tmxTypes';

interface SendSmsDialogContainerProps {
  matchUp?: MatchUpInterface;
  isOpen?: boolean;
  selectedPlayers?: ParticipantInterface[];
  onClose(): void;
  onExited?(): void;
}

const SendSmsDialogContainer: React.FC<React.PropsWithChildren<SendSmsDialogContainerProps>> = ({
  matchUp,
  isOpen,
  selectedPlayers,
  onClose,
  onExited,
}) => {
  const smsService = useSmsService();
  const { tournamentId } = useParams<{ tournamentId: string }>();
  const [{ sendSmsLoading }, setSendSmsResult] = useState<{ sendSmsLoading?: boolean }>({ sendSmsLoading: false });

  const handleOnSendSMS = async (message: string, selectedPlayersIds: string[]) => {
    setSendSmsResult({ sendSmsLoading: true });
    const sendSmsResult = await smsService.sendSMS(message, selectedPlayersIds, matchUp?.tournamentId || tournamentId);
    setSendSmsResult({ sendSmsLoading: false });
    return sendSmsResult;
  };
  return (
    <SendSMSDialog
      isOpen={isOpen}
      loading={sendSmsLoading}
      participants={selectedPlayers}
      onClose={onClose}
      onExited={onExited}
      onSendSms={handleOnSendSMS}
    />
  );
};

export default SendSmsDialogContainer;
